class Brand {
    constructor() {
        this.default    = 'mymuesli';
        this.identifier = App.Layout.body.data('brand');
    }
}
App.Brand = new Brand();